<template>
  <div class="card" style="width: 18rem;" v-tooltip="'test'" >
      <img :src="img_link" class="card-img-top" alt="..." style="cursor: pointer;">
      <div class="card-body">
        <!-- <p>Nome do curso: {{courses}}</p> -->
        <p class="mb-1" style="color: #8e8e8e;"><small>Capítulo X {{chapterIndex}} :</small></p>
        <h5 class="text-center mb-3"> <strong>  Xxxx Xxxxxx </strong></h5>
        <p class="mb-1" style="color: #8e8e8e;"><small>Próximo:</small></p>
        <h5 class="text-center mb-3"> <strong>  Xxxx Xxxxxx </strong></h5>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    img_link: String,
    chapterIndex: Number,
    chapterName: String,
    NextLesson: String
  },
  // mounted () {
  //   console.log(typeof chapterName)
  //   console.log(typeof img_link)
  // }
//   data: () => ({
//     // courses: [],
//     lessonIndex: 0,
//     lessonsData: [],
//     chapterIndex: 0,
//     chaptersData: [],
//     chapter: 0,
//     chapterName: '',
//     nameOfVideoSequence: ''
//   }),
//   created () {
//     this.fetchUserCourses();
//   },
//   methods: {
//     fetchUserCourses() {
//       this.loadingCourses = true;
//       this.axios
//         .get("/courses")
//         .then(response => {
//           this.courses = response.data.data;
//           this.loadingCourses = false;
//           this.listCourses();
//         })
//         .catch(error => {
//           this.result = "Erro ao carregar Cursos. Tente novamente. \n " + error;
//           // this.openModal('result');
//           console.log(error);
//           this.loadingCourses = false;
//         });
//     },
//     openCourse(index) {
//       this.open = "ShowCourse";
//       this.courseIndex = index;
//     },
//     playLesson(lesson, lessonIndex, lessons, chapterIndex, chapters) {
//       this.lessonIndex = lessonIndex;
//       this.lessonsData = lessons;
//       this.watchLesson = lesson;
//       this.chapterIndex = chapterIndex;
//       this.chaptersData = chapters;
//       this.tempWatchedLesson = this.watchLesson.watched;
//       this.tempReviewLesson = this.watchLesson.review;
//       this.open = "playLesson";

//       // Scroll to top
//       var element = document.getElementById("topDiv");
//       var top = element.offsetTop;
//       window.scrollTo(0, top);
//     },
//   },
//   computed: {
//     theme() {
//       return this.$auth.user().layout;
//     },
//     sequence() {
//       let lessonIndex = -1;
//       let chapterIndex = -1;
//       let lessonIndexNoOpcional = -1;
//       let chapterIndexNoOpcional = -1;
//       let lessonWithOpcional = -1;
//       let lessonNoOpcional = -1;
//       let lessonsNoOpcional = -1;
//       let lessons = [];
//       let first = false;
//       for (
//           let chapter = 0;
//           chapter < this.courses[this.courseIndex].chapters.data.length;
//           chapter++
//       ) {
//           lessons = this.courses[this.courseIndex].chapters.data[chapter].lessons.data;
//           lessonWithOpcional = _.findIndex(
//               lessons,
//               function(o) {
//                   return o.watched === null;
//               }
//           );
//           if (lessonWithOpcional !== -1 && !first) {
//               chapterIndex = chapter;
//               lessonIndex = lessonWithOpcional;
//               first = true;
//           }
//           lessonNoOpcional = _.findIndex(
//               lessonsNoOpcional,
//               function(o) {
//                   return o.watched === null && o.required !== 0;
//               }
//           );
//           if (lessonNoOpcional !== -1) {
//               chapterIndexNoOpcional = chapter;
//               lessonIndexNoOpcional = lessonNoOpcional;
//           } else {
//               chapterIndexNoOpcional = -1;
//               lessonIndexNoOpcional = -1;
//           }
//       }
//       return { lessonIndex, chapterIndex, lessonIndexNoOpcional, chapterIndexNoOpcional };
//     }
//   },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/CardVideos.vue